<template>
  <div>
    <transition name="el-fade-in-linear">
      <div v-if="isRoute" class="main">
        <index-header :common="common" :activeIndex="activeIndex" :showNav="showNav" :navColor="navColor" @positionVal="getPosition"></index-header>
        <index-main :screenWidth="screenWidth" :smallWidth="smallWidth"></index-main>
        <index-foot></index-foot>
      </div>
    </transition>
    <!--    <div :class="fly===1?'position_up_top':'fly_up_top'" @click="backTop" v-if="showFly!==1"></div>-->
  </div>
</template>

<script>
import {indexMain, indexHeader, indexFoot} from './components'

export default {
  name: "index",
  data() {
    return {
      common: 'rightHead',
      screenWidth: document.body.clientWidth,
      smallWidth: 0,
      activeIndex: '1',
      fly: 1,
      showFly: 1,
      oldScrollTop: 0,
      showNav: true,
      isRoute:true,
      navColor:0
    }
  },
  components: {
    indexMain,
    indexHeader,
    indexFoot
  },
  mounted() {
    let that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        this.updateStore(that.screenWidth);
      })()
    };
    that.updateActive();
    window.addEventListener('scroll', this.handleScroll, true)
  },
  created() {
    let that = this;
    that.updateStore(that.screenWidth);
    let active = sessionStorage.getItem('active');
    if (active !== undefined && active !== null) {
      that.activeIndex = active;
    }
  },
  methods: {
    updateStore(val) {
      let that = this;
      if (val <= 768) {
        that.common = 'leftHead';
        that.smallWidth = 1;
      } else {
        that.common = 'rightHead';
        that.smallWidth = 0;
      }
    },
    updateActive() {
      let that = this;
      let router = that.$route.path;
      let active = '';
      if (router === '/') {
        active = '1';
      } else if (router === '/smartCommunity') {
        active = '2';
      } else if (router === '/bigData') {
        active = '3';
      } else if (router === '/companyIntroduce') {
        active = '4';
      }
      that.activeIndex = active;
    },
    changeActive() {
      let that = this;
      let active = sessionStorage.getItem('active');
      if (active !== undefined && active !== null) {
        that.activeIndex = active;
      }
    },
    handleScroll() {
      let that = this;
      that.scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (that.scrollTop > 400 && that.screenWidth > 480) {
        that.showFly = 0;
      } else {
        that.showFly = 1
      }
      if (that.scrollTop < that.oldScrollTop || that.scrollTop <= 80) {
        if(that.scrollTop<80){
          that.navColor= 1;
        }else{
          that.navColor= 0;
        }
        that.showNav = true;

      } else {
        that.showNav = false;
        that.navColor=0;
      }
      that.oldScrollTop = that.scrollTop;
      // console.log(that.scrollTop);
    },
    getPosition(val){
      console.log(val);
      // let that=this;
      // that.scrollTop=val;
      // if(val!==undefined){
      //   // this.$nextTick(() => {
      //     let timer = setInterval(() => {
      //       document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset  = that.scrollTop;
      //       if (that.scrollTop === val) {
      //         clearInterval(timer)
      //       }
      //     }, 8);
      //     // let a=document.querySelector('main').scrollTop;
      //     // console.log(a)
      //   // })
      // }
      // console.log('scrollTop',that.scrollTop);
      // console.log('scrollTop2',document.body.scrollTop );
      // console.log('scrollTop3',document.documentElement.scrollTop);
      // console.log('scrollTop4',window.pageYOffset);
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
          that.fly = 0;
          that.showFly = 0;
        }
      }, 16);
      setTimeout(() => {
        that.fly = 1;
        that.showFly = 1;
      }, 1000);
    },

  },
  watch: {
    screenWidth(val) {
      this.updateStore(val)
    },
    $route(to,from){
      let that=this;
      that.isRoute=false;
      setTimeout(function (){
        that.isRoute=true
        that.updateActive();
      },200)

    }
  },
}
</script>

<style scoped>
.winWidth{
  width: 100%;
  overflow: hidden;
}
.fade-enter-active, .fade-leave-active {
  will-change: transform;
  transition: all 400ms;
}

.fade-enter {
  opacity: 0;
  transform: rotateY(0deg);
}

.fade-leave-active {
  opacity: 0;
  transform: rotateY(90deg);
}
.position_up_top {
  width: 113px;
  height: 129px;
  position: fixed;
  right: 10px;
  bottom: 100px;
  background-image: url("../assets/image/index/blackFly.png");
  background-repeat: no-repeat;
  z-index: 20;
}

.position_up_top:hover {
  width: 113px;
  height: 129px;
  position: fixed;
  right: 10px;
  bottom: 100px;
  background-image: url("../assets/image/index/flyImg.png");
  background-repeat: no-repeat;
  z-index: 20;
}

.fly_up_top {
  width: 113px;
  height: 129px;
  position: fixed;
  right: 10px;
  bottom: 100px;
  animation: example 500ms linear 1;
  z-index: 20;
  background-image: url("../assets/image/index/flyImg.png");
  background-repeat: no-repeat;
}

@keyframes example {
  0% {
    position: fixed;
    right: 10px;
    bottom: 100px;
    z-index: 20;
  }
  25% {
    position: fixed;
    right: 10px;
    bottom: 25%;
    z-index: 20;
  }
  50% {
    position: fixed;
    right: 10px;
    bottom: 50%;
    z-index: 20;
  }
  75% {
    position: fixed;
    right: 10px;
    bottom: 75%;
    z-index: 20;
  }
  100% {
    position: fixed;
    right: 10px;
    bottom: 100%;
    z-index: 20;
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/index.vue